import {GuestAddress} from './guest-address.model';
export class Guest {
  lastName: string;
  firstName: string;
  address: GuestAddress;
  phoneNumber: string;
  rewardsClubNumber: string;
  id: number;

  constructor(firstName?: string, lastName?: string, rewardsClubNumber?: string, id?: number) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.rewardsClubNumber = rewardsClubNumber;
    this.id = id;
    this.address = new GuestAddress();
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/guest/guest.model.ts